import restAction from "@/js/store/module/common/restAction";
const api = restAction.actions.COWORK_REST_SIMPLE_ACTION;
const emoticonPath = '/static/emoticon/';

export default {

	/* 이모티콘 src default 위치 반환: 보드 의견 */
	getEmoticonImg(tenantId, img) {
		return '<img src="' + emoticonPath + tenantId + '/' + img +'" />';
	},

	/* 이모티콘 src default 위치 반환: 보드 의견 */
	getEmoticonaddImg(tenantId, img) {
		return emoticonPath + tenantId + '/' + img;
	},

	/* 이모티콘 src default 위치 반환: 의사결정 */
	getEmoticonSrc(tenantId, img) {
		if (img.indexOf('.gif') < 0) img += '.gif';
		return emoticonPath + tenantId + '/' + img;
	},

	/* 이모티콘 사용처 */
	getEmoticonLocation(type) {
		let emoticonLocation = [
			{'type': 'brdCommentEmoticon', 'location': 'BOARD_COMMENT'},
			{'type': 'decisionEmoticon', 'location': 'DECISION_COMMENT'}
		]

		let arry = {};
		let location;
		if(type === null) {
			emoticonLocation.forEach(item => {
				arry[item.type] = false;
			})
		}else {
			emoticonLocation.forEach(item => {
				if(item.type === type) {
					location = item.location;
				}
			})
		}
		return type === null ? arry : location;
	},

	/* 이모티콘 사용 계열사 체크 */
	checkEmoticonUse(location) {
		return api({}, {
			url: "/api/copaper/emoticon/checkEmoticonUse",
			method: "post",
			params: {
				location: location,
			}
		}).then(resp => {
			if (!resp) { return; }
			if (resp.errorCode) { console.log('/checkEmoticonUse errorCode', resp.errorCode); }
			return resp.result;
		}).catch((err) => console.log('/checkEmoticonUse err ', err));
	},

	/* 이모티콘 리스트 가져오기 */
	getEmoticonList(tenantId, location) {
		return api({}, {
			url: "/api/copaper/emoticon/getEmoticonList",
			method: "post",
			params: {
				location: location,
			}
		}).then(resp => {
			if (!resp) { return; }
			if (resp.errorCode) { console.log('/getEmoticonList errorCode', resp.errorCode); }
			return resp.result;
		}).catch((err) => console.log('/getEmoticonList err ', err));
	},

}


// WEBPACK FOOTER //
// ./src/js/emoticon/emoticon.js